import React from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';

// Hoisted-once style objects — keeps Recharts from re-mounting on every render.
const CHART_MARGIN = { top: 5, right: 10, left: 0, bottom: 0 };
const TICK = { fontSize: 11 };
const TOOLTIP_STYLE = { borderRadius: 8, fontSize: 12 };
const RSI_TICKS = [30, 50, 70];
const RSI_DOMAIN = [0, 100];
const volumeTickFormatter = (v) => `${(v / 1e6).toFixed(0)}M`;
const volumeTooltipFormatter = (value) => [`${(Number(value) / 1e6).toFixed(2)}M`, 'Volume'];

export const RSIPanel = ({ data }) => (
  <div className="h-28 mt-2" data-testid="chart-rsi-area">
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="date" hide />
        <YAxis domain={RSI_DOMAIN} ticks={RSI_TICKS} tick={TICK} width={60} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        <ReferenceLine y={70} stroke="#ef4444" strokeDasharray="3 3" />
        <ReferenceLine y={30} stroke="#22c55e" strokeDasharray="3 3" />
        <Line type="monotone" dataKey="rsi" stroke="#6366f1" dot={false} strokeWidth={1.5} name="RSI(14)" />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);

export const VolumePanel = ({ data }) => (
  <div className="h-24 mt-2" data-testid="chart-volume-area">
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="date" hide />
        <YAxis tick={TICK} width={60} tickFormatter={volumeTickFormatter} />
        <Tooltip contentStyle={TOOLTIP_STYLE} formatter={volumeTooltipFormatter} />
        <Bar dataKey="volume" fill="#a855f7" opacity={0.6} name="Volume" />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);
